import React from 'react'

import CHROME_ICON from '../pngs/Chrome.png'

export const ChromeIcon = () => {
  return <img src={CHROME_ICON} width={24} height={24} />
}
